/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Upload_FilesInputs */

const en_nav_app_upload_files = /** @type {(inputs: Nav_App_Upload_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload files`)
};

const es_nav_app_upload_files = /** @type {(inputs: Nav_App_Upload_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir archivos`)
};

/**
* | output |
* | --- |
* | "Upload files" |
*
* @param {Nav_App_Upload_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_upload_files = /** @type {((inputs?: Nav_App_Upload_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Upload_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_upload_files(inputs)
	return en_nav_app_upload_files(inputs)
});